<div class="faq-list" [class.faq-list--disabled]="!enabled">
  <div class="faq-list__toolbar">
    <div class="faq-list__search">
      <nb-form-field>
        <input
          type="text"
          nbInput
          fullWidth
          [placeholder]="'pages.tutors.faq.searchPlaceholder' | translate"
          [(ngModel)]="searchText"
          (ngModelChange)="resetPage()"
        />
        <button nbSuffix nbButton ghost type="button">
          <nb-icon
            *ngIf="searchText"
            icon="close-outline"
            pack="eva"
            (click)="searchText = ''; resetPage()"
          ></nb-icon>
          <nb-icon *ngIf="!searchText" icon="search-outline" pack="eva"></nb-icon>
        </button>
      </nb-form-field>
    </div>

    <button
      nbButton
      status="basic"
      size="small"
      ghost
      [nbTooltip]="'pages.tutors.faq.downloadTemplateTooltip' | translate"
      (click)="downloadTemplate()"
    >
      <nb-icon icon="download-outline" pack="eva"></nb-icon>
      {{ 'pages.tutors.faq.downloadTemplate' | translate }}
    </button>
    <button
      nbButton
      status="basic"
      size="small"
      ghost
      [disabled]="importing"
      [nbTooltip]="'pages.tutors.faq.importCsvTooltip' | translate"
      (click)="csvInput.click()"
    >
      <nb-icon icon="upload-outline" pack="eva"></nb-icon>
      {{ (importing ? 'pages.tutors.faq.importing' : 'pages.tutors.faq.importCsv') | translate }}
    </button>
    <input
      #csvInput
      type="file"
      accept=".csv,text/csv"
      hidden
      (change)="onCsvSelected($event)"
    />
  </div>

  <div class="faq-list__scroll">
    <div
      class="faq-list__row faq-list__row--head"
      [style.gridTemplateColumns]="gridTemplateColumns"
    >
      <span class="col-topic">
        {{ 'pages.tutors.faq.topic' | translate }}
        <span class="col-resizer" (mousedown)="startResize($event, 'topic')"></span>
      </span>
      <span class="col-tags">
        {{ 'pages.tutors.faq.tags' | translate }}
        <span class="col-resizer" (mousedown)="startResize($event, 'tags')"></span>
      </span>
      <span class="col-question">
        {{ 'pages.tutors.faq.question' | translate }}
        <span class="col-resizer" (mousedown)="startResize($event, 'question')"></span>
      </span>
      <span class="col-answer">
        {{ 'pages.tutors.faq.answer' | translate }}
        <span class="col-resizer" (mousedown)="startResize($event, 'answer')"></span>
      </span>
      <span class="col-active">{{ 'pages.tutors.faq.active' | translate }}</span>
      <span class="col-actions"></span>
    </div>

    <ng-container *ngFor="let row of pagedRows; let idx = index; let count = count">
      <div
        class="faq-list__row"
        [style.gridTemplateColumns]="gridTemplateColumns"
        [class.is-dirty]="row.status === 'dirty'"
        [class.is-error]="row.status === 'error'"
      >
        <input
          nbInput
          fullWidth
          class="col-topic"
          [(ngModel)]="row.topic"
          (ngModelChange)="scheduleSave(row)"
          [placeholder]="'pages.tutors.faq.topicPlaceholder' | translate"
        />
        <div class="col-tags tag-cell">
          <span
            class="tag-chip"
            *ngFor="let t of row.tags"
            [style.background]="tagColor(t)"
          >
            <span class="tag-chip__label">{{ t }}</span>
            <button
              type="button"
              class="tag-chip__remove"
              (click)="onTagRemove(row, t)"
              [attr.aria-label]="'buttons.delete' | translate"
            >×</button>
          </span>
          <input
            #tagInput
            type="text"
            class="tag-input"
            (keydown.enter)="onTagAdd(row, tagInput.value); tagInput.value = ''; $event.preventDefault()"
            (blur)="onTagAdd(row, tagInput.value); tagInput.value = ''"
          />
        </div>
        <textarea
          nbInput
          fullWidth
          rows="2"
          class="col-question"
          [(ngModel)]="row.question"
          (ngModelChange)="scheduleSave(row)"
          (blur)="save(row)"
          [placeholder]="'pages.tutors.faq.questionPlaceholder' | translate"
        ></textarea>
        <textarea
          nbInput
          fullWidth
          rows="2"
          class="col-answer"
          [(ngModel)]="row.answer"
          (ngModelChange)="scheduleSave(row)"
          (blur)="save(row)"
          [placeholder]="'pages.tutors.faq.answerPlaceholder' | translate"
        ></textarea>
        <nb-toggle
          class="col-active"
          [(ngModel)]="row.is_active"
          (ngModelChange)="save(row)"
        ></nb-toggle>
        <div class="col-actions">
          <span class="status-pill" [attr.data-status]="row.status">
            <ng-container [ngSwitch]="row.status">
              <span *ngSwitchCase="'saving'" class="dot dot--saving"></span>
              <span *ngSwitchCase="'dirty'" class="dot dot--dirty" title="{{ 'pages.tutors.faq.statusDirty' | translate }}"></span>
              <span *ngSwitchCase="'saved'" class="dot dot--saved" title="{{ 'pages.tutors.faq.statusSaved' | translate }}"></span>
              <span *ngSwitchCase="'error'" class="dot dot--error" title="{{ 'pages.tutors.faq.statusError' | translate }}"></span>
            </ng-container>
          </span>
          <div class="row-action-wrapper">
            <button
              type="button"
              class="row-action-trigger"
              [class.is-open]="isMenuOpen(row)"
              [attr.aria-label]="'buttons.actions' | translate"
              (click)="toggleMenu($event, row)"
            >
              <nb-icon icon="more-vertical-outline" pack="eva"></nb-icon>
            </button>
            <div
              *ngIf="isMenuOpen(row)"
              class="row-action-menu"
              [class.row-action-menu--up]="count > 2 && idx >= count - 2"
              (click)="$event.stopPropagation()"
            >
              <button
                type="button"
                class="row-action-item row-action-item--danger"
                (click)="remove(row)"
              >
                <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
                <span>{{ 'buttons.delete' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="!loading && filteredRows.length === 0" class="faq-list__empty">
      {{ (searchText ? 'pages.tutors.faq.noResults' : 'pages.tutors.faq.empty') | translate }}
    </div>
  </div>

  <button nbButton status="basic" size="small" (click)="addRow()">
    + {{ 'pages.tutors.faq.addRow' | translate }}
  </button>

  <app-pagination
    *ngIf="filteredRows.length > pageSize || pageSize !== pageSizeOptions[0]"
    [totalItems]="filteredRows.length"
    [itemsPerPage]="pageSize"
    [currentPage]="currentPage"
    [pageSizeOptions]="pageSizeOptions"
    (pageChanged)="onPageChange($event)"
    (itemsPerPageChange)="onPageSizeChange($event)"
  ></app-pagination>
</div>
